import { createSelector } from 'reselect';

export const initialState = {};

const initialValues = (state = initialState) => state.constructionBudget;

export const getConstructionBudgetInitialValues = createSelector(initialValues, (values) => values);
